import { initialState, MetaState } from './selectors';
import { FocusSuccess, META_ACTIONS, UPDATE_FOCUS_SUCCESS } from './actions';
import { actions as authActions } from '@ui/store/auth';

export default (state: MetaState = initialState, action: any) => {
  switch (action.type) {
    case META_ACTIONS.SUCCEEDED: {
      const { meta } = (action as any).payload;

      return { ...state, ...meta };
    }

    case UPDATE_FOCUS_SUCCESS: {
      const { payload } = action as FocusSuccess;

      return {
        ...state,
        collections: state.collections.map(c => {
          if (c.id === payload.focus.collectionId) {
            const focus = {
              ...payload.focus,
            };
            delete focus.collectionId;
            return {
              ...c,
              focus,
            };
          }
          return c;
        }),
      };
    }

    case authActions.AUTH_ACTIONS.LOGOUT_SUCCEEDED: {
      return { ...state, ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/meta/reducer.ts